export default "__VITE_ASSET__XhJJOCAE__"